document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('cc-deal-form');
  if (!form) return;

  var button = document.getElementById('cc-add');
  if (button) {
    button.setAttribute('aria-label', 'Add to cart and checkout');
  }

  form.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;

    var artwork = document.getElementById('cc-artwork');
    var sendLater = document.getElementById('cc-send-later');
    var hasArtwork = artwork && artwork.files && artwork.files.length > 0;
    var sendingLater = sendLater && sendLater.checked;

    if (!hasArtwork && !sendingLater) return;

    event.preventDefault();

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            throw new Error(payload.description || 'Unable to add this item to cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        window.alert(error.message || 'Something went wrong. Please try again.');
      });
  });
});
